import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { set_sync_status } from "../../actions/Sync";
import TeamMemberInfoCard from "./TeamMemberInfoCard";

const TeamManagement = (props) => {

    const TeamSettings = useSelector((state) => state.Team);
    const UserSettings = useSelector((state) => state.User);
    const dispatch = useDispatch();

    const [viewMode, setViewMode] = useState('cards'); // 'cards' or 'list'
    const [filterName, setFilterName] = useState('');
    const [filterTeam, setFilterTeam] = useState('');
    const [filterStatus, setFilterStatus] = useState('active'); // 'active', 'inactive', or ''

    const init = useEffect(() => {
        if (UserSettings.slotsSynced == false || UserSettings.teamSynced == false) {
            dispatch(set_sync_status("asap_full"));
        }
    }, []);

    // Get all team members as array
    const allTeamMembers = Object.values(TeamSettings);

    // Get unique teams
    const uniqueTeams = [...new Set(allTeamMembers.map(m => m.group).filter(Boolean))].sort();

    // Filter team members
    const filteredTeamMembers = allTeamMembers.filter(member => {
        const nameMatch = !filterName ||
            member.realName.toLowerCase().includes(filterName.toLowerCase()) ||
            member.userName.toLowerCase().includes(filterName.toLowerCase());
        const teamMatch = !filterTeam || member.group === filterTeam;
        const statusMatch = !filterStatus || member.status === filterStatus;
        return nameMatch && teamMatch && statusMatch;
    });

    const resetFilters = () => {
        setFilterName('');
        setFilterTeam('');
        setFilterStatus('active');
    };


    return (
        <div className="container mt-5">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1>
                    <i className="bi bi-people me-2 text-primary"></i>
                    Team-Übersicht
                </h1>
                <div className="btn-group btn-group-sm">
                    <button
                        className={`btn ${viewMode === 'cards' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setViewMode('cards')}
                        title="Kartenansicht"
                    >
                        <i className="bi bi-grid-3x3-gap"></i>
                    </button>
                    <button
                        className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setViewMode('list')}
                        title="Listenansicht"
                    >
                        <i className="bi bi-list-ul"></i>
                    </button>
                </div>
            </div>

            {allTeamMembers.length < 1 ? (
                <div className="alert alert-info">
                    <i className="bi bi-info-circle me-2"></i>
                    Wir synchronisieren gerade noch etwas...
                </div>
            ) : (
                <>
                    {/* Filter Toolbar */}
                    <div className="card shadow-sm mb-4">
                        <div className="card-header bg-white border-bottom">
                            <div className="d-flex align-items-center justify-content-between">
                                <h5 className="mb-0">
                                    <i className="bi bi-funnel me-2 text-primary"></i>
                                    Filter
                                </h5>
                                <button
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={resetFilters}
                                    title="Alle Filter zurücksetzen"
                                >
                                    <i className="bi bi-x-circle me-1"></i>
                                    Zurücksetzen
                                </button>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row g-3">
                                {/* Name Filter */}
                                <div className="col-lg-4 col-md-6">
                                    <label className="form-label fw-semibold small text-muted">
                                        <i className="bi bi-search me-1"></i>
                                        Name / Username
                                    </label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0">
                                            <i className="bi bi-person text-muted"></i>
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control border-start-0 ps-2"
                                            placeholder="Suchen..."
                                            value={filterName}
                                            onChange={e => setFilterName(e.target.value)}
                                        />
                                        {filterName && (
                                            <button
                                                className="btn btn-outline-secondary"
                                                onClick={() => setFilterName('')}
                                            >
                                                <i className="bi bi-x"></i>
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {/* Team Filter */}
                                <div className="col-lg-4 col-md-6">
                                    <label className="form-label fw-semibold small text-muted">
                                        <i className="bi bi-people-fill me-1"></i>
                                        Team
                                    </label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0">
                                            <i className="bi bi-people text-muted"></i>
                                        </span>
                                        <select
                                            value={filterTeam}
                                            className="form-select border-start-0 ps-2"
                                            onChange={e => setFilterTeam(e.target.value)}
                                        >
                                            <option value="">Alle Teams</option>
                                            {uniqueTeams.map(team => (
                                                <option key={team} value={team}>{team}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Status Filter */}
                                <div className="col-lg-4 col-md-6">
                                    <label className="form-label fw-semibold small text-muted">
                                        <i className="bi bi-check-circle me-1"></i>
                                        Status
                                    </label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0">
                                            <i className="bi bi-toggle-on text-muted"></i>
                                        </span>
                                        <select
                                            value={filterStatus}
                                            className="form-select border-start-0 ps-2"
                                            onChange={e => setFilterStatus(e.target.value)}
                                        >
                                            <option value="">Alle Status</option>
                                            <option value="active">Aktiv</option>
                                            <option value="inactive">Inaktiv</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* Active Filters Display */}
                            {(filterName || filterTeam || filterStatus) && (
                                <div className="mt-3 pt-3 border-top">
                                    <small className="text-muted fw-semibold me-2">Aktive Filter:</small>
                                    {filterName && (
                                        <span className="badge bg-primary me-2">
                                            <i className="bi bi-search me-1"></i>
                                            {filterName}
                                            <i className="bi bi-x ms-1 cursor-pointer" onClick={() => setFilterName('')}></i>
                                        </span>
                                    )}
                                    {filterTeam && (
                                        <span className="badge bg-warning me-2">
                                            <i className="bi bi-people me-1"></i>
                                            {filterTeam}
                                            <i className="bi bi-x ms-1 cursor-pointer" onClick={() => setFilterTeam('')}></i>
                                        </span>
                                    )}
                                    {filterStatus && (
                                        <span className="badge bg-success me-2">
                                            <i className="bi bi-toggle-on me-1"></i>
                                            {filterStatus === 'active' ? 'Aktiv' : 'Inaktiv'}
                                            <i className="bi bi-x ms-1 cursor-pointer" onClick={() => setFilterStatus('')}></i>
                                        </span>
                                    )}
                                    <small className="text-muted">({filteredTeamMembers.length} Ergebnis{filteredTeamMembers.length !== 1 ? 'se' : ''})</small>
                                </div>
                            )}
                        </div>
                    </div>

                    {filteredTeamMembers.length === 0 ? (
                        <div className="alert alert-info m-3">
                            <i className="bi bi-info-circle me-2"></i>
                            Keine Team-Mitglieder gefunden.
                        </div>
                    ) : viewMode === 'cards' ? (
                        <div className="row">
                            {filteredTeamMembers.map(member => (
                                <div
                                    key={member.userName}
                                    className={`col-12 col-md-6 col-xxl-4 mb-4 ${member.status === 'inactive' ? 'opacity-25' : ''}`}
                                >
                                    {member.status === 'active' ? (
                                        <a href={`mailto:${member.userName}@unternehmen.online`}>
                                            <TeamMemberInfoCard TeamMember={member} />
                                        </a>
                                    ) : (
                                        <TeamMemberInfoCard TeamMember={member} />
                                    )}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="card shadow-sm">
                            <div className="card-body p-0">
                                <table className="table mb-0 small table-hover">
                                    <thead className="table-light sticky-top">
                                        <tr>
                                            <th className="align-middle border-end">
                                                <i className="bi bi-person me-1"></i>
                                                Name
                                            </th>
                                            <th className="align-middle border-end">
                                                <i className="bi bi-at me-1"></i>
                                                Username
                                            </th>
                                            <th className="align-middle border-end">
                                                <i className="bi bi-envelope me-1"></i>
                                                E-Mail
                                            </th>
                                            <th className="align-middle border-end">
                                                <i className="bi bi-people me-1"></i>
                                                Team
                                            </th>
                                            <th className="align-middle border-end">
                                                <i className="bi bi-toggle-on me-1"></i>
                                                Status
                                            </th>
                                            <th className="align-middle text-center" style={{width: '100px'}}>
                                                <i className="bi bi-gear me-1"></i>
                                                Kontakt
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredTeamMembers.map(member => (
                                            <tr key={member.userName} className={member.status === 'inactive' ? 'opacity-25' : ''}>
                                                <td className="align-middle">
                                                    <i className="bi bi-person-circle me-2 text-primary"></i>
                                                    <strong>{member.realName}</strong>
                                                </td>
                                                <td className="align-middle">{member.userName}</td>
                                                <td className="align-middle">
                                                    <a href={`mailto:${member.userName}@unternehmen.online`} className="text-decoration-none">
                                                        {member.userName}@unternehmen.online
                                                    </a>
                                                </td>
                                                <td className="align-middle">
                                                    <span className="badge bg-light text-dark border">
                                                        {member.group || '-'}
                                                    </span>
                                                </td>
                                                <td className="align-middle">
                                                    {member.status === 'active' ? (
                                                        <span className="badge bg-success">
                                                            <i className="bi bi-check-circle me-1"></i>
                                                            Aktiv
                                                        </span>
                                                    ) : (
                                                        <span className="badge bg-warning">
                                                            <i className="bi bi-x-circle me-1"></i>
                                                            Inaktiv
                                                        </span>
                                                    )}
                                                </td>
                                                <td className="align-middle text-center">
                                                    <a
                                                        href={`mailto:${member.userName}@unternehmen.online`}
                                                        className="btn btn-sm btn-outline-primary"
                                                        title="E-Mail senden"
                                                    >
                                                        <i className="bi bi-envelope"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default TeamManagement